//****************************LOG OF ACTIVITY*******************************************************
// Date        Developed by           Sprint & Task      Description
// 8-11-2019   Prakhar                17   & PH-1260     Redirection of 'View full profile' in the mobile app
//                                                       to nurse splash dashboard.
//**************************************************************************************************
'use strict';

    App.controller('NurseRedirectController', ['$rootScope', '$scope', '$http', '$cookies', '$cookieStore', 'ngDialog', '$timeout', '$localStorage',
    '$sessionStorage', '$state', 'Api', 'toastr', 'authApi', '$stateParams', '$loading', 'offsetDST', 'sessionService', 'userService',
    function ($rootScope, $scope, $http, $cookies, $cookieStore, ngDialog, $timeout, $localStorage, $sessionStorage, $state, Api, toastr, authApi, $stateParams, $loading, offsetDST, sessionService, userService) {
        var token = $stateParams['token'];
        var redirectPage = $stateParams['r'];
        if (!token) {
            window.location.hash = '/login';
            window.location.reload();
        }else{
            userService.loginRedirect(token)
                .then(function(response){
                    $localStorage['token'] = response;
                    sessionService.updateNotifications();
                    
                    return sessionService.updateProfessional();
                })
                .then(function() {
									if (redirectPage && !sessionService.professionalData.data?.briefcase.consentedAt) {
									  	redirectPage = 'profile';
									}

									if (redirectPage == "profile") {
                      $state.go('dashboard.profile');
                  } else if (redirectPage == "license") {
                      $state.go('dashboard.license');
                  } else {
							  			$state.go('splash');
                  }
                })
								.catch(function (error) {
                    toastr.error(error.message);
                    window.location.hash = '/login';
                    window.location.reload();
                });
        }
    }]);

